module.exports = __webpack_public_path__ + "static/media/achievement-abs-of-steel.65ef9604.svg";